import { combineReducers } from 'redux';
import {
  GET_PARENT_PETITIONS_REQUEST,
  GET_PARENT_PETITIONS_SUCCESS,
  GET_PARENT_PETITIONS_FAILED,
  SET_PARENT_PETITION_ID,
} from './actionTypes';
import dashboardPetitions from './DashboardPetitions/reducer';
import dashboardInfo from './DashboardInfo/reducer';

const initialState = {
  parentPetitionId: 0,
  parentPetitions: [],
  loading: false,
  error: '',
};

const mainReducer = (state = initialState, {
  type, error, parentPetitions, parentPetitionId,
}) => {
  switch (type) {
    case GET_PARENT_PETITIONS_REQUEST:
      return { ...state, loading: true };
    case GET_PARENT_PETITIONS_SUCCESS:
      return {
        ...state,
        parentPetitions,
        loading: false,
      };
    case GET_PARENT_PETITIONS_FAILED:
      return { ...state, loading: false, error };
    case SET_PARENT_PETITION_ID:
      return { ...state, parentPetitionId };
    default:
      return state;
  }
};

const dashboardReducer = combineReducers({
  main: mainReducer,
  petitionsTable: dashboardPetitions,
  dashboardInfo,
});

export default dashboardReducer;
